import { notify } from "./feedback";

export function initReader(): void {
  const article = document.querySelector<HTMLElement>(".article-detail");
  if (!article) return;
  const progress = document.querySelector<HTMLElement>("[data-reading-progress]");
  let frame = 0;
  function updateProgress(): void {
    if (!article || !progress) return;
    frame = 0;
    const rect = article.getBoundingClientRect();
    const range = Math.max(1, rect.height - innerHeight);
    const percent = Math.min(100, Math.max(0, -rect.top / range * 100));
    progress.style.setProperty("--reading-progress", String(percent / 100));
    progress.setAttribute("aria-valuenow", String(Math.round(percent)));
  }
  function schedule(): void {
    if (!frame) frame = requestAnimationFrame(updateProgress);
  }
  document.addEventListener("scroll", schedule, { passive: true });
  window.addEventListener("resize", schedule, { passive: true });
  new ResizeObserver(schedule).observe(article);
  schedule();

  function articleURL(): string {
    const url = new URL(location.href);
    url.hash = "";
    return url.href;
  }
  async function copy(): Promise<void> {
    try {
      await navigator.clipboard.writeText(articleURL());
      notify("文章链接已复制");
    } catch {
      notify("无法自动复制，请复制浏览器地址栏中的链接。");
    }
  }
  document.querySelector("[data-copy-article]")?.addEventListener("click", () => void copy());
  document.querySelector("[data-share-article]")?.addEventListener("click", async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: article.querySelector("h1")?.textContent ?? document.title, url: articleURL() });
        return;
      } catch (error) {
        if (error instanceof DOMException && error.name === "AbortError") return;
      }
    }
    await copy();
  });
}
